import { render, staticRenderFns } from "./RiderLayout.vue?vue&type=template&id=5bfd1666&lang=pug"
import script from "./RiderLayout.vue?vue&type=script&lang=js"
export * from "./RiderLayout.vue?vue&type=script&lang=js"
import style0 from "./RiderLayout.vue?vue&type=style&index=0&id=5bfd1666&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports